import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { AppAuthHttpService } from '../../http/app.auth.http.service';
import { ResponseUtilService } from '../../shared/utils/response-util.service';
import { Headers, RequestOptions } from '@angular/http';
import { MatchingAgency } from '../models/matching-agency';
import { MatchingAgencyCandidate } from '../models/matching-agency-candidate';
import { Page } from '../../shared/models/page';
import { List } from 'immutable';
import { PropertyMatch } from '../models/property-match';
import { MatchingProperty } from '../models/matching-property';
import { MatchingAgencyService } from '../../shared/matching-agency/matching-agency.service';
import { MatchingAgencyCandidateAssign } from '../models/matching-agency-candidate-assign';
import { MatchingAgencyAdd } from '../models/matching-agency-add';
import { AgencyLookupDetail } from '../../shared/models/agency-lookup-detail';

@Injectable()
export class MatchingAgencyHttpService {
  private aggregateBaseURL =  '/api/matching/agency';
  private agencyMatchesSearchURL: string = this.environment.baseUrl + this.aggregateBaseURL + '/search';
  private agencyMatchesAssignURL: string = this.environment.baseUrl + this.aggregateBaseURL + '/assign/candidate';
  private agencyMatchesAddURL: string = this.environment.baseUrl + this.aggregateBaseURL + '/assign/new';

  constructor(private http: AppAuthHttpService,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService) {

  }

  search(taCode: string, chainCode: string): Observable<AgencyLookupDetail> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers }); // Create a request option

    return this.http.get(`${this.agencyMatchesSearchURL}?taCode=${taCode}&chainCode=${chainCode}`, options)
      .map(response => response.json())
      .catch(response => this.responseUtilService.handleError(response))
      .share();
  }

  getMatches(page: number, size: number, sort: string): Observable<Page<MatchingAgency>> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers }); // Create a request option


    return this.http.get(`${this.agencyMatchesSearchURL}?page=${page}&size=${size}&${sort}`, options)
      .map(response => response.json())
      .catch(response => this.responseUtilService.handleError(response))
      .share();
  }

  assign(candidateAssign: MatchingAgencyCandidateAssign): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });

    return this.http.post(this.agencyMatchesAssignURL, JSON.stringify(candidateAssign.toJS()), options)
      .catch(response => this.responseUtilService.handleError(response))
      .share();
  }

  add(newRec: MatchingAgencyAdd): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });

    return this.http.post(this.agencyMatchesAddURL, JSON.stringify(newRec.toJS()), options)
      .map(response => response.json())
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/matching-agency.http.service.ts